import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { sessionService } from '../../application/SessionService';
import * as routing from '../../constants/Routing';
import { UserValidation } from '../auth/user-validation/UserValidation';
import { Auth } from './../auth/Auth';

const GridContainer = styled(Grid)`
  min-height: 100vh;
`;

const PublicComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isLogged = sessionService.isLogged();

  useEffect(() => {
    if (isLogged) {
      const redirectTo = searchParams.get(`redirectTo`);
      if ((redirectTo ?? ``) !== ``) {
        // TODO: Control if URL is from highway??
        navigate(redirectTo as string);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged, searchParams]);

  // Only set new password is allowed when user is logged in.
  if (isLogged && !location.pathname?.includes(`/user/new-password`)) return <Navigate to={routing.PRIVATE_HIGHWAY} />;

  return (
    <GridContainer container direction="column" wrap="nowrap">
      <div
        style={{
          height: `100vh`,
          overflowY: `hidden`,
          display: `flex`,
          flexDirection: `row`,
          width: `100%`,
        }}
      >
        <Routes>
          <Route path={routing.AUTH.LOGIN} element={<Auth route="login" />} />
          <Route path={routing.AUTH.USER_VALIDATION} element={<UserValidation />} />
          <Route path={routing.AUTH.ORGANIZATION_ACCEPT_USER_INVITATION} element={<Auth route="invitation" />} />
          <Route path={routing.AUTH.REGISTER} element={<Auth route="register" />} />
          <Route path={routing.AUTH.RESET_PASSWORD} element={<Auth route="reset-password" />} />
          <Route path={routing.AUTH.NEW_PASSWORD} element={<Auth route="reset-password" />} />
          <Route path={routing.NO_MATCHES} element={<Navigate to={routing.AUTH.LOGIN} />} />
        </Routes>
      </div>
    </GridContainer>
  );
};

export default PublicComponent;
